import { ErrorOverlay } from '@/components/pages'

export default {
  components: { ErrorOverlay },

  data: () => ({
    loading: false,
    error_dialog: false,
    error_message: '',    
  }),
}
